import React, { memo } from 'react';
import * as Icon from 'ubs-icons';
import { COLOR } from '../../../common/constant';
import PropTypes from 'prop-types';

const DocumentError = memo(({ message }) => (
  <div className="u_text-center u_p-4 u_color-white">
    <Icon.Warning size={24} fill={COLOR.u_red} />
    <p>{message || "Unable to generate preview for this document"}</p>
  </div>
));

DocumentError.propTypes = {
  message: PropTypes.string
};

export default DocumentError; 